
export default {
  props: {
    inverse: {
      type: Boolean,
      default: false,
    },
  },
}
